import { AiOutlineSchedule } from "react-icons/ai";
import {
  FaArrowsLeftRightToLine,
  FaArrowsRotate,
  FaArrowTrendUp,
  FaBook,
  FaBox,
  FaBriefcaseMedical,
  FaCalendarDay,
  FaCalendarDays,
  FaCalendarWeek,
  FaChartArea,
  FaChartLine,
  FaChartPie,
  FaChartSimple,
  FaCity,
  FaClipboardCheck,
  FaClock,
  FaClockRotateLeft,
  FaCubes,
  FaCubesStacked,
  FaDiagramProject,
  FaEarthAmericas,
  FaEllipsis,
  FaEnvelope,
  FaEnvelopesBulk,
  FaFileWaveform,
  FaFlaskVial,
  FaFont,
  FaGaugeHigh,
  FaGaugeSimpleHigh,
  FaGears,
  FaHandHoldingMedical,
  FaHospital,
  FaHourglass,
  FaHouse,
  FaHouseMedical,
  FaIdCard,
  FaIdCardClip,
  FaLayerGroup,
  FaLink,
  FaListCheck,
  FaListUl,
  FaLocationDot,
  FaMobileScreenButton,
  FaPalette,
  FaPlantWilt,
  FaRankingStar,
  FaReadme,
  FaRegChartBar,
  FaRegCircleQuestion,
  FaScaleUnbalanced,
  FaScaleUnbalancedFlip,
  FaSquareCaretDown,
  FaStethoscope,
  FaSuitcaseRolling,
  FaBuilding,
  FaTable,
  FaTableCells,
  FaTableCellsLarge,
  FaTableList,
  FaTriangleExclamation,
  FaUmbrellaBeach,
  FaUser,
  FaUserGear,
  FaUserLock,
  FaUsers,
  FaUsersSlash,
  FaUserTag,
  FaUserTie,
  FaUsersViewfinder,
  FaWarehouse,
  FaTags,
  FaArrowUpRightDots,
} from "react-icons/fa6";
import * as routes from "./routes";
import { ROLES } from "./roleConstants";

const MRIIcon = () => (
  <span
    className="mri-menu-icon"
    style={{
      WebkitMaskImage: "url('/assets/icons/mri-scan-icon.svg')",
      maskImage: "url('/assets/icons/mri-scan-icon.svg')",
    }}
    aria-hidden="true"
  />
);

export const SIDE_BAR_MENUS = [
  {
    title: "Home",
    icon: <FaHouse />,
    link: routes.BASE_PATH_PREFIX,
    roles: [
      ROLES.ADMIN,
      ROLES.OPS_TEAM,
      ROLES.SHEDULER,
      ROLES.PROVIDER,
      ROLES.STAKE_HOLDERS,
      ROLES.TENANT_ADMIN,
      ROLES.SUPER_ADMIN,
    ],
  },

  {
    title: "Tenant Management",
    icon: <FaBuilding />,
    link: routes.TENANT_MANAGEMENT,
    roles: [ROLES.SUPER_ADMIN],
  },
  // {
  //   title: "TimeZone",
  //   icon: <FaListCheck />,
  //   link: routes.MASTER_TIMEZONE_MANAGEMENT,
  //   roles: [ROLES.SUPER_ADMIN],
  // },
  {
    title: "User Management",
    icon: <FaUserGear />,
    link: routes?.USERMANAGEMENT,
    roles: [ROLES.SUPER_ADMIN],
  },

  {
    title: "Providers",
    icon: <FaBriefcaseMedical />,
    roles: [
      ROLES.ADMIN,
      ROLES.OPS_TEAM,
      ROLES.SHEDULER,
      ROLES.STAKE_HOLDERS,
      ROLES.TENANT_ADMIN,
    ],
    subMenus: [
      {
        title: "Provider List",
        icon: <FaUsers />,
        link: routes.RAD_LIST,
        roles: [
          ROLES.ADMIN,
          ROLES.OPS_TEAM,
          ROLES.SHEDULER,
          ROLES.STAKE_HOLDERS,
          ROLES.TENANT_ADMIN,
        ],
      },
      {
        title: "Unassigned Providers",
        icon: <FaUsersSlash />,
        link: routes.UNASSIGNED_PROVIDER_LIST,
        roles: [
          ROLES.ADMIN,
          ROLES.OPS_TEAM,
          ROLES.SHEDULER,
          ROLES.STAKE_HOLDERS,
          ROLES.TENANT_ADMIN,
        ],
      },
      // {
      //   title: "Capacity Input",
      //   icon: <FaBox />,
      //   link: routes.CAPACITY_INPUT,
      //   roles: [
      //     ROLES.ADMIN,
      //     ROLES.OPS_TEAM,
      //     ROLES.SHEDULER,
      //     ROLES.STAKE_HOLDERS,
      //     ROLES.TENANT_ADMIN,
      //   ],
      // },
      {
        title: "Capacity",
        icon: <FaBox />,
        link: routes.CAPACITY_INPUT_NEW,
        roles: [
          ROLES.ADMIN,
          ROLES.OPS_TEAM,
          ROLES.SHEDULER,
          ROLES.STAKE_HOLDERS,
          ROLES.TENANT_ADMIN,
        ],
      },
      // { title: "Custom View", icon: <FaUsersViewfinder />, link: "/Explorer", roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER] },
      {
        title: "Custom View",
        icon: <FaUsersViewfinder />,
        link: routes.CUSTOM_VIEW,
        roles: [
          ROLES.ADMIN,
          ROLES.OPS_TEAM,
          ROLES.SHEDULER,
          ROLES.STAKE_HOLDERS,
          ROLES.TENANT_ADMIN,
        ],
      },
      {
        title: "Leadership Bulk Update",
        icon: <FaEnvelopesBulk />,
        link: routes.RAD_LEADERSHIP_BULK_UPDATE,
        roles: [
          ROLES.ADMIN,
          ROLES.OPS_TEAM,
          ROLES.SHEDULER,
          ROLES.TENANT_ADMIN,
        ],
      },
      {
        title: "Hourly Volume Share",
        icon: <FaChartSimple />,
        link: routes.RAD_HOURLY_VOLUME_SHARE,
        roles: [
          ROLES.ADMIN,
          ROLES.OPS_TEAM,
          ROLES.SHEDULER,
          ROLES.TENANT_ADMIN,
        ],
      },
      {
        title: "Annual Hour Tracker",
        icon: <FaHourglass />,
        link: routes.ANNUAL_HOUR_TRACKER,
        roles: [
          ROLES.ADMIN,
          ROLES.OPS_TEAM,
          ROLES.SHEDULER,
          ROLES.TENANT_ADMIN,
        ],
      },
      {
        title: "Audit Logs",
        icon: <FaClockRotateLeft />,
        link: routes.AUDIT_LOGS,
        roles: [
          ROLES.ADMIN,
          ROLES.OPS_TEAM,
          ROLES.SHEDULER,
          ROLES.TENANT_ADMIN,
        ],
      },
      {
        title: "State License",
        icon: <FaIdCard />,
        link: routes.STATE_LICENSE,
        roles: [
          ROLES.ADMIN,
          ROLES.OPS_TEAM,
          ROLES.SHEDULER,
          ROLES.STAKE_HOLDERS,
          ROLES.TENANT_ADMIN,
        ],
      },
      {
        title: "License & Privileges Power Sync",
        icon: <FaArrowsRotate />,
        link: routes.LICENSE_PRIVILEGE_POWER_SYNC,
        roles: [
          ROLES.ADMIN,
          ROLES.OPS_TEAM,
          ROLES.SHEDULER,
          ROLES.STAKE_HOLDERS,
          ROLES.TENANT_ADMIN,
        ],
      },
    ],
  },

  // Provider Login
  {
    title: "Profile",
    icon: <FaUser />,
    link: routes.RAD_PROFILE,
    roles: [ROLES.PROVIDER],
  },
  {
    title: "Live Available Shifts",
    icon: <FaScaleUnbalanced />,
    link: routes.LIVE_AVAILABLE_SHIFTS,
    roles: [ROLES.PROVIDER, ROLES.STAKE_HOLDERS],
  },
  {
    title: "Scheduling",
    icon: <FaCalendarDays />,
    link: routes.SCHEDULING_CALENDAR,
    roles: [ROLES.PROVIDER],
  },

  {
    title: "Facilities",
    icon: <FaCity />,
    roles: [
      ROLES.ADMIN,
      ROLES.OPS_TEAM,
      ROLES.SHEDULER,
      ROLES.STAKE_HOLDERS,
      ROLES.TENANT_ADMIN,
    ],
    subMenus: [
      {
        title: "Facility List",
        icon: <FaListUl />,
        link: routes.SITE_LIST,
        roles: [
          ROLES.ADMIN,
          ROLES.OPS_TEAM,
          ROLES.SHEDULER,
          ROLES.STAKE_HOLDERS,
          ROLES.TENANT_ADMIN,
        ],
      },
      {
        title: "Unassigned Facilities",
        icon: <FaTriangleExclamation />,
        link: routes.UNASSIGNED_SITES,
        roles: [
          ROLES.ADMIN,
          ROLES.OPS_TEAM,
          ROLES.SHEDULER,
          ROLES.TENANT_ADMIN,
        ],
      },
      {
        title: "Alias Management",
        icon: <FaFont />,
        link: routes.SITEALIASMANAGEMENT_SITE,
        roles: [
          ROLES.ADMIN,
          ROLES.OPS_TEAM,
          ROLES.SHEDULER,
          ROLES.TENANT_ADMIN,
        ],
      },
      {
        title: "Hourly Volume Share",
        icon: <FaChartSimple />,
        link: routes.SITE_HOURLY_VOLUME_SHARE,
        roles: [
          ROLES.ADMIN,
          ROLES.OPS_TEAM,
          ROLES.SHEDULER,
          ROLES.TENANT_ADMIN,
        ],
      },
      {
        title: "Custom View",
        icon: <FaUsersViewfinder />,
        link: routes.SITE_CUSTOM_VIEW,
        roles: [
          ROLES.ADMIN,
          ROLES.OPS_TEAM,
          ROLES.SHEDULER,
          ROLES.STAKE_HOLDERS,
          ROLES.TENANT_ADMIN,
        ],
      },
    ],
  },
  {
    title: "Admin",
    icon: <FaUserLock />,
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
    subMenus: [
      {
        title: "Hierarchy Management",
        icon: <FaDiagramProject />,
        roles: [
          ROLES.ADMIN,
          ROLES.OPS_TEAM,
          ROLES.SHEDULER,
          ROLES.TENANT_ADMIN,
        ],
        subMenus: [
          // { title: "Main Practice", icon: <FaLocationDot />, link: routes?.MAIN_PRACTICE, roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER] },
          // { title: "Regional Practice Worklist", icon: <FaMapPin />, link: routes?.REGIONALPRACTICEWORKLIST, roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER] },
          {
            title: "National",
            icon: <FaEarthAmericas />,
            link: routes?.NATIONAL,
            roles: [
              ROLES.ADMIN,
              ROLES.OPS_TEAM,
              ROLES.SHEDULER,
              ROLES.TENANT_ADMIN,
            ],
          },
          {
            title: "Region",
            icon: <FaLocationDot />,
            link: routes?.REGION,
            roles: [
              ROLES.ADMIN,
              ROLES.OPS_TEAM,
              ROLES.SHEDULER,
              ROLES.TENANT_ADMIN,
            ],
          },
          // { title: "Regional Practice", icon: <FaLocationDot />, link: routes?.REGIONALPRACTICE, roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER] },
          // {
          //   title: "RPCE",
          //   icon: <FaPlantWilt />,
          //   link: routes?.RPCE,
          //   roles: [
          //     ROLES.ADMIN,
          //     ROLES.OPS_TEAM,
          //     ROLES.SHEDULER,
          //     ROLES.TENANT_ADMIN,
          //   ],
          // },
          {
            title: "Practice",
            icon: <FaHospital />,
            link: routes?.PRACTICE,
            roles: [
              ROLES.ADMIN,
              ROLES.OPS_TEAM,
              ROLES.SHEDULER,
              ROLES.TENANT_ADMIN,
            ],
          },
          {
            title: "Sub Practice",
            icon: <FaHouseMedical />,
            link: routes?.SUBPRACTICE,
            roles: [
              ROLES.ADMIN,
              ROLES.OPS_TEAM,
              ROLES.SHEDULER,
              ROLES.TENANT_ADMIN,
            ],
          },
        ],
      },
      {
        title: "Demand Management",
        icon: <FaChartLine />,
        roles: [
          ROLES.ADMIN,
          ROLES.OPS_TEAM,
          ROLES.SHEDULER,
          ROLES.TENANT_ADMIN,
        ],
        subMenus: [
          {
            title: "Priority Mapping",
            icon: <FaRankingStar />,
            link: routes?.PRIORITYSLAMAPPING,
            roles: [
              ROLES.ADMIN,
              ROLES.OPS_TEAM,
              ROLES.SHEDULER,
              ROLES.TENANT_ADMIN,
            ],
          },
          {
            title: "Facility Coverage Matrix",
            icon: <FaTableCells />,
            link: routes?.SITECOVERAGEMATRIX,
            roles: [
              ROLES.ADMIN,
              ROLES.OPS_TEAM,
              ROLES.SHEDULER,
              ROLES.TENANT_ADMIN,
            ],
          },
          {
            title: "Worklist Definition",
            icon: <FaGears />,
            link: routes?.WORKLIST_DEFINITION,
            roles: [
              ROLES.ADMIN,
              ROLES.OPS_TEAM,
              ROLES.SHEDULER,
              ROLES.TENANT_ADMIN,
            ],
          },
          {
            title: "Worklist Group",
            icon: <FaLayerGroup />,
            link: routes?.WORKLIST_GROUP,
            roles: [
              ROLES.ADMIN,
              ROLES.OPS_TEAM,
              ROLES.SHEDULER,
              ROLES.TENANT_ADMIN,
            ],
          },
          // {
          //   title: "Worklist",
          //   icon: <FaClipboardList />,
          //   link: routes?.WORKLIST,
          //   roles: [
          //     ROLES.ADMIN,
          //     ROLES.OPS_TEAM,
          //     ROLES.SHEDULER,
          //     ROLES.TENANT_ADMIN,
          //   ],
          // },
          {
            title: "Section Worklist Mapping",
            icon: <FaArrowsLeftRightToLine />,
            link: routes?.SECTIONWORKLIST,
            roles: [
              ROLES.ADMIN,
              ROLES.OPS_TEAM,
              ROLES.SHEDULER,
              ROLES.TENANT_ADMIN,
            ],
          },
          {
            title: "DLS",
            icon: <FaCalendarWeek />,
            link: routes?.DLS_CONFIGURATION,
            roles: [
              ROLES.ADMIN,
              ROLES.OPS_TEAM,
              ROLES.SHEDULER,
              ROLES.TENANT_ADMIN,
            ],
          },
        ],
      },
      {
        title: "Scheduling",
        icon: <FaCalendarDay />,
        roles: [
          ROLES.ADMIN,
          ROLES.OPS_TEAM,
          ROLES.SHEDULER,
          ROLES.TENANT_ADMIN,
        ],
        subMenus: [
          {
            title: "Task Configuration",
            icon: <FaListCheck />,
            link: routes.TASK_CONFIGURATION,
            roles: [
              ROLES.ADMIN,
              ROLES.OPS_TEAM,
              ROLES.SHEDULER,
              ROLES.TENANT_ADMIN,
            ],
          },
          {
            title: "Day of Week Configuration",
            icon: <FaCalendarDays />,
            link: routes?.DAY_OF_WEEK_CONFIGURATION,
            roles: [
              ROLES.ADMIN,
              ROLES.OPS_TEAM,
              ROLES.SHEDULER,
              ROLES.TENANT_ADMIN,
            ],
          },
          {
            title: "Shift Hour Configuration",
            icon: <FaClock />,
            link: routes?.SHIFT_HOUR_CONFIGURATION,
            roles: [
              ROLES.ADMIN,
              ROLES.OPS_TEAM,
              ROLES.SHEDULER,
              ROLES.TENANT_ADMIN,
            ],
          },
          // {
          //   title: "Holiday Planner",
          //   icon: <FaUmbrellaBeach />,
          //   link: routes?.HOLIDAYPLANNER,
          //   roles: [
          //     ROLES.ADMIN,
          //     ROLES.OPS_TEAM,
          //     ROLES.SHEDULER,
          //     ROLES.TENANT_ADMIN,
          //   ],
          // },
        ],
      },
      {
        title: "Tag Management",
        icon: <FaTags />,
        link: routes?.TAG_CATEGORY_CONFIGURATION,
        roles: [
          ROLES.ADMIN,
          ROLES.OPS_TEAM,
          ROLES.SHEDULER,
          ROLES.TENANT_ADMIN,
        ],
      },
      {
        title: "User Management",
        icon: <FaUserGear />,
        link: routes?.USERMANAGEMENT,
        roles: [
          ROLES.ADMIN,
          ROLES.OPS_TEAM,
          ROLES.SHEDULER,
          ROLES.TENANT_ADMIN,
          ROLES.SUPER_ADMIN,
        ],
      },
      {
        title: "License & Privilege Status Mapping",
        icon: <FaIdCardClip />,
        link: routes?.LICENSE_PRIVILEGE_STATUS_MAPPING,
        roles: [
          ROLES.ADMIN,
          ROLES.OPS_TEAM,
          ROLES.SHEDULER,
          ROLES.TENANT_ADMIN,
        ],
      },
      {
        title: "Email Notification",
        icon: <FaEnvelope />,
        link: routes?.EMAIL_NOTIFICATION,
        roles: [ROLES.TENANT_ADMIN],
      },
      {
        title: "Dropdown Management",
        icon: <FaSquareCaretDown />,
        roles: [
          ROLES.ADMIN,
          ROLES.OPS_TEAM,
          ROLES.SHEDULER,
          ROLES.TENANT_ADMIN,
        ],
        subMenus: [
          {
            title: "Time Zone",
            icon: <FaListCheck />,
            link: routes?.TIMEZONE_MANAGEMENT,
            roles: [
              ROLES.ADMIN,
              ROLES.OPS_TEAM,
              ROLES.SHEDULER,
              ROLES.TENANT_ADMIN,
            ],
          },
          {
            title: "Modality",
            icon: <FaListCheck />,
            link: routes?.MODALITY,
            roles: [
              ROLES.ADMIN,
              ROLES.OPS_TEAM,
              ROLES.SHEDULER,
              ROLES.TENANT_ADMIN,
            ],
          },
          // {
          //   title: "Priority",
          //   icon: <FaListCheck />,
          //   link: routes?.PRIORITY,
          //   roles: [
          //     ROLES.ADMIN,
          //     ROLES.OPS_TEAM,
          //     ROLES.SHEDULER,
          //     ROLES.TENANT_ADMIN,
          //   ],
          // },
          {
            title: "Provider Dropdowns",
            icon: <FaStethoscope />,
            roles: [
              ROLES.ADMIN,
              ROLES.OPS_TEAM,
              ROLES.SHEDULER,
              ROLES.TENANT_ADMIN,
            ],
            subMenus: [
              {
                title: "Provider Status",
                icon: <FaListCheck />,
                link: routes.RAD_STATUS,
                roles: [
                  ROLES.ADMIN,
                  ROLES.OPS_TEAM,
                  ROLES.SHEDULER,
                  ROLES.TENANT_ADMIN,
                ],
              },
              {
                title: "Provider Type",
                icon: <FaListCheck />,
                link: routes.RAD_TYPE,
                roles: [
                  ROLES.ADMIN,
                  ROLES.OPS_TEAM,
                  ROLES.SHEDULER,
                  ROLES.TENANT_ADMIN,
                ],
              },
              {
                title: "Provider Category",
                icon: <FaListCheck />,
                link: routes?.STAFF_CATEGORY,
                roles: [
                  ROLES.ADMIN,
                  ROLES.OPS_TEAM,
                  ROLES.SHEDULER,
                  ROLES.TENANT_ADMIN,
                ],
              },
              {
                title: "Staffing Agency / Entity",
                icon: <FaListCheck />,
                link: routes?.STAFFING_AGENCY,
                roles: [
                  ROLES.ADMIN,
                  ROLES.OPS_TEAM,
                  ROLES.SHEDULER,
                  ROLES.TENANT_ADMIN,
                ],
              },
              {
                title: "Staff Primary Location",
                icon: <FaListCheck />,
                link: routes?.STAFF_PRIMARY_LOCATION,
                roles: [
                  ROLES.ADMIN,
                  ROLES.OPS_TEAM,
                  ROLES.SHEDULER,
                  ROLES.TENANT_ADMIN,
                ],
              },
              {
                title: "Committees",
                icon: <FaListCheck />,
                link: routes?.COMMITTEES,
                roles: [
                  ROLES.ADMIN,
                  ROLES.OPS_TEAM,
                  ROLES.SHEDULER,
                  ROLES.TENANT_ADMIN,
                ],
              },
              {
                title: "Subspecialty",
                icon: <FaListCheck />,
                link: routes?.SUBSPECIALITY,
                roles: [
                  ROLES.ADMIN,
                  ROLES.OPS_TEAM,
                  ROLES.SHEDULER,
                  ROLES.TENANT_ADMIN,
                ],
              },
              {
                title: "Schedule Type",
                icon: <FaListCheck />,
                link: routes.SCHEDULETYPE,
                roles: [
                  ROLES.ADMIN,
                  ROLES.OPS_TEAM,
                  ROLES.SHEDULER,
                  ROLES.TENANT_ADMIN,
                ],
              },
              {
                title: "Week Rotation",
                icon: <FaListCheck />,
                link: routes?.WEEK_ROTATION,
                roles: [
                  ROLES.ADMIN,
                  ROLES.OPS_TEAM,
                  ROLES.SHEDULER,
                  ROLES.TENANT_ADMIN,
                ],
              },
              {
                title: "Specialty Cases",
                icon: <FaListCheck />,
                link: routes?.SPECIALTY_CASES,
                roles: [
                  ROLES.ADMIN,
                  ROLES.OPS_TEAM,
                  ROLES.SHEDULER,
                  ROLES.TENANT_ADMIN,
                ],
              },
              {
                title: "Week Rotation Template",
                icon: <FaListCheck />,
                link: routes?.WEEK_ROTATION_TEMPLATE,
                roles: [
                  ROLES.ADMIN,
                  ROLES.OPS_TEAM,
                  ROLES.SHEDULER,
                  ROLES.TENANT_ADMIN,
                ],
              },
              {
                title: "Request Status",
                icon: <FaListCheck />,
                link: routes?.REQUEST_STATUS,
                roles: [
                  ROLES.ADMIN,
                  ROLES.OPS_TEAM,
                  ROLES.SHEDULER,
                  ROLES.TENANT_ADMIN,
                ],
              },
              {
                title: "RVU Rate",
                icon: <FaListCheck />,
                link: routes?.RVURATE,
                roles: [
                  ROLES.ADMIN,
                  ROLES.OPS_TEAM,
                  ROLES.SHEDULER,
                  ROLES.TENANT_ADMIN,
                ],
              },
              {
                title: "Time to Partnership",
                icon: <FaListCheck />,
                link: routes?.PARTNERSHIP_TIME,
                roles: [
                  ROLES.ADMIN,
                  ROLES.OPS_TEAM,
                  ROLES.SHEDULER,
                  ROLES.TENANT_ADMIN,
                ],
              },
              {
                title: "Partnership Status",
                icon: <FaListCheck />,
                link: routes?.PARTNERSHIP_STATUS,
                roles: [
                  ROLES.ADMIN,
                  ROLES.OPS_TEAM,
                  ROLES.SHEDULER,
                  ROLES.TENANT_ADMIN,
                ],
              },
              {
                title: "Partnership Rate",
                icon: <FaListCheck />,
                link: routes?.PARTNERSHIP_RATE,
                roles: [
                  ROLES.ADMIN,
                  ROLES.OPS_TEAM,
                  ROLES.SHEDULER,
                  ROLES.TENANT_ADMIN,
                ],
              },
              {
                title: "Note Category",
                icon: <FaListCheck />,
                link: routes.PROVIDER_NOTE_TYPE,
                roles: [
                  ROLES.ADMIN,
                  ROLES.OPS_TEAM,
                  ROLES.SHEDULER,
                  ROLES.TENANT_ADMIN,
                ],
              },
              {
                title: "Document Category",
                icon: <FaListCheck />,
                link: routes.PROVIDER_DOCUMENT_TYPE,
                roles: [
                  ROLES.ADMIN,
                  ROLES.OPS_TEAM,
                  ROLES.SHEDULER,
                  ROLES.TENANT_ADMIN,
                ],
              },
              // {
              //   title: "Future Section Change",
              //   icon: <FaListCheck />,
              //   link: routes?.FUTURE_SECTION_CHANGE,
              //   roles: [
              //     ROLES.ADMIN,
              //     ROLES.OPS_TEAM,
              //     ROLES.SHEDULER,
              //     ROLES.TENANT_ADMIN,
              //   ],
              // },
              {
                title: "Provider Title",
                icon: <FaListCheck />,
                link: routes?.RAD_DEGREE,
                roles: [
                  ROLES.ADMIN,
                  ROLES.OPS_TEAM,
                  ROLES.SHEDULER,
                  ROLES.TENANT_ADMIN,
                ],
              },
              {
                title: "Provider Communication Type",
                icon: <FaListCheck />,
                link: routes?.RAD_COMMUNICATION_TYPE,
                roles: [
                  ROLES.ADMIN,
                  ROLES.OPS_TEAM,
                  ROLES.SHEDULER,
                  ROLES.TENANT_ADMIN,
                ],
              },
            ],
          },
          {
            title: "Facility Dropdowns",
            icon: <FaCity />,
            roles: [
              ROLES.ADMIN,
              ROLES.OPS_TEAM,
              ROLES.SHEDULER,
              ROLES.TENANT_ADMIN,
            ],
            subMenus: [
              {
                title: "Facility Status",
                icon: <FaListCheck />,
                link: routes?.SITE_STATUS,
                roles: [
                  ROLES.ADMIN,
                  ROLES.OPS_TEAM,
                  ROLES.SHEDULER,
                  ROLES.TENANT_ADMIN,
                ],
              },
              {
                title: "Billing Management",
                icon: <FaListCheck />,
                link: routes?.BILLING_MANAGEMENT,
                roles: [
                  ROLES.ADMIN,
                  ROLES.OPS_TEAM,
                  ROLES.SHEDULER,
                  ROLES.TENANT_ADMIN,
                ],
              },
              {
                title: "Trauma Facility Level",
                icon: <FaListCheck />,
                link: routes?.TRAUMA_FACILITY_LEVEL,
                roles: [
                  ROLES.ADMIN,
                  ROLES.OPS_TEAM,
                  ROLES.SHEDULER,
                  ROLES.TENANT_ADMIN,
                ],
              },
              // {
              //   title: "Encore Section",
              //   icon: <FaListCheck />,
              //   link: routes?.QGENDA_SECTION,
              //   roles: [
              //     ROLES.ADMIN,
              //     ROLES.OPS_TEAM,
              //     ROLES.SHEDULER,
              //     ROLES.TENANT_ADMIN,
              //   ],
              // },
            ],
          },
          {
            title: "Leadership Dropdowns",
            icon: <FaUserTie />,
            roles: [
              ROLES.ADMIN,
              ROLES.OPS_TEAM,
              ROLES.SHEDULER,
              ROLES.TENANT_ADMIN,
            ],
            subMenus: [
              {
                title: "User Designations",
                icon: <FaUserTag />,
                link: routes?.DESIGNATION,
                roles: [
                  ROLES.ADMIN,
                  ROLES.OPS_TEAM,
                  ROLES.SHEDULER,
                  ROLES.TENANT_ADMIN,
                ],
              },
            ],
          },
        ],
      },
      {
        title: "Color Management",
        icon: <FaPalette />,
        roles: [
          ROLES.ADMIN,
          ROLES.OPS_TEAM,
          ROLES.SHEDULER,
          ROLES.TENANT_ADMIN,
        ],
        subMenus: [
          {
            title: "Coverage Gap Color Configuration",
            icon: <FaChartArea />,
            link: routes?.COVERAGE_GAP,
            roles: [
              ROLES.ADMIN,
              ROLES.OPS_TEAM,
              ROLES.SHEDULER,
              ROLES.TENANT_ADMIN,
            ],
          },
          {
            title: "Simulator Color Configuration",
            icon: <FaFlaskVial />,
            link: routes?.SIMULATOR_COLOR_CONFIGURATION,
            roles: [
              ROLES.ADMIN,
              ROLES.OPS_TEAM,
              ROLES.SHEDULER,
              ROLES.TENANT_ADMIN,
            ],
          },
          {
            title: "Block Planning Color Configuration",
            icon: <FaTableCellsLarge />,
            link: routes?.BLOCK_PLANNING,
            roles: [
              ROLES.ADMIN,
              ROLES.OPS_TEAM,
              ROLES.SHEDULER,
              ROLES.TENANT_ADMIN,
            ],
          },
        ],
      },
    ],
  },
  // {
  //   title: "Schedules",
  //   icon: <AiOutlineSchedule />,
  //   roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  //   subMenus: [
  //     {
  //       title: "Scheduling",
  //       icon: <FaCalendarDays />,
  //       link: routes.SCHEDULING_CALENDAR,
  //       roles: [
  //         ROLES.ADMIN,
  //         ROLES.OPS_TEAM,
  //         ROLES.SHEDULER,
  //         ROLES.TENANT_ADMIN,
  //       ],
  //     },
  //     {
  //       title: "Sharable Links",
  //       icon: <FaLink />,
  //       link: routes.SCHEDULING_CALENDAR_SHARE_LINKS,
  //       roles: [
  //         ROLES.ADMIN,
  //         ROLES.OPS_TEAM,
  //         ROLES.SHEDULER,
  //         ROLES.TENANT_ADMIN,
  //       ],
  //     },
  //     {
  //       title: "Provider Request",
  //       icon: <FaClipboardCheck />,
  //       link: routes.PROVIDER_REQUEST,
  //       roles: [
  //         ROLES.ADMIN,
  //         ROLES.OPS_TEAM,
  //         ROLES.SHEDULER,
  //         ROLES.TENANT_ADMIN,
  //       ],
  //     },
  //   ],
  // },
  {
    title: "Schedules",
    icon: <AiOutlineSchedule />,
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
    subMenus: [
      {
        title: "Scheduling",
        icon: <FaCalendarDays />,
        link: routes.SCHEDULING_CALENDAR,
        roles: [
          ROLES.ADMIN,
          ROLES.OPS_TEAM,
          ROLES.SHEDULER,
          ROLES.TENANT_ADMIN,
        ],
      },
      {
        title: "Sharable Links",
        icon: <FaLink />,
        link: routes.SCHEDULING_CALENDAR_SHARE_LINKS,
        roles: [
          ROLES.ADMIN,
          ROLES.OPS_TEAM,
          ROLES.SHEDULER,
          ROLES.TENANT_ADMIN,
        ],
      },
      {
        title: "Provider Request",
        icon: <FaClipboardCheck />,
        link: routes.PROVIDER_REQUEST,
        roles: [
          ROLES.ADMIN,
          ROLES.OPS_TEAM,
          ROLES.SHEDULER,
          ROLES.TENANT_ADMIN,
        ],
      },
    ],
  },
  {
    title: "Exam",
    icon: <MRIIcon />,
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
    subMenus: [
      {
        title: "Raw Exam Data",
        icon: <FaFileWaveform />,
        link: routes.RAW_EXAM_DATA,
        roles: [
          ROLES.ADMIN,
          ROLES.OPS_TEAM,
          ROLES.SHEDULER,
          ROLES.TENANT_ADMIN,
        ],
      },
      {
        title: "Exam Data",
        icon: <FaWarehouse />,
        link: routes.EXAM_DATA,
        roles: [
          ROLES.ADMIN,
          ROLES.OPS_TEAM,
          ROLES.SHEDULER,
          ROLES.TENANT_ADMIN,
        ],
      },
      {
        title: "Exam Metrics",
        icon: <FaGaugeHigh />,
        link: routes.EXAM_METRICS,
        roles: [
          ROLES.ADMIN,
          ROLES.OPS_TEAM,
          ROLES.SHEDULER,
          ROLES.TENANT_ADMIN,
        ],
      },
      {
        title: "Misc. Facility Data",
        icon: <FaEllipsis />,
        link: routes.MISCELLANEOUS_SITE_DATA,
        roles: [
          ROLES.ADMIN,
          ROLES.OPS_TEAM,
          ROLES.SHEDULER,
          ROLES.TENANT_ADMIN,
        ],
      },
      // { title: "Read", icon: <FaReadme />, link: routes.EXAM_DATA_READ, roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER] },
      // { title: "Unread", icon: <FaBook />, link: routes.UNREAD, roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER] },
      // { title: "TAT", icon: <FaNfcDirectional />, link: routes.TAT_DATA, roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER] }
    ],
  },

  // {
  //   title: "Reports",
  //   icon: <FaChartLine />,
  //   roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.STAKE_HOLDERS],
  //   subMenus: [
  //     {
  //       title: "Encore Daily Report",
  //       icon: <FaChartSimple />,
  //       link: routes.MATRIX_DAILY_REPORT,
  //       roles: [
  //         ROLES.ADMIN,
  //         ROLES.OPS_TEAM,
  //         ROLES.SHEDULER,
  //         ROLES.STAKE_HOLDERS,
  //       ],
  //     },
  //     {
  //       title: "Performance Dashboard",
  //       icon: <FaChartArea />,
  //       link: routes.PERFORMANCE_DASHBOARD,
  //       roles: [
  //         ROLES.ADMIN,
  //         ROLES.OPS_TEAM,
  //         ROLES.SHEDULER,
  //         ROLES.STAKE_HOLDERS,
  //       ],
  //     },
  //     {
  //       title: "Coverage Gap Tool",
  //       icon: <FaArrowsLeftRightToLine />,
  //       link: routes.COVERAGE_GAP_TOOL,
  //       roles: [
  //         ROLES.ADMIN,
  //         ROLES.OPS_TEAM,
  //         ROLES.SHEDULER,
  //         ROLES.STAKE_HOLDERS,
  //       ],
  //     },
  //     {
  //       title: "Holiday Gap Tool",
  //       icon: <FaSuitcaseRolling />,
  //       link: routes.HOLIDAY_GAP_TOOL,
  //       roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER],
  //     },
  //     {
  //       title: "Privilege Power Sync",
  //       icon: <FaArrowsRotate />,
  //       link: routes.PRIVILEGE_POWER_SYNC,
  //       roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER],
  //     },
  //     {
  //       title: "Report Configuration",
  //       icon: <FaGears />,
  //       link: routes.REPORT_CONFIGURATION,
  //       roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER],
  //     },
  //     // { title: "Report Configuration", icon: <FaGears />, link: routes.REPORT_CONFIGURATION, roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER] }
  //   ],
  // },
  {
    title: "Reports",
    icon: <FaChartLine />,
    roles: [
      ROLES.ADMIN,
      ROLES.OPS_TEAM,
      ROLES.SHEDULER,
      ROLES.STAKE_HOLDERS,
      ROLES.TENANT_ADMIN,
      ROLES.SUPER_ADMIN,
    ],
    subMenus: [
      {
        title: "Daily Report",
        icon: <FaChartSimple />,
        link: routes.DAILY_REPORT,
        roles: [
          ROLES.ADMIN,
          ROLES.OPS_TEAM,
          ROLES.SHEDULER,
          ROLES.STAKE_HOLDERS,
          ROLES.TENANT_ADMIN,
          ROLES.SUPER_ADMIN,
        ],
      },
      {
        title: "Market Volume Share",
        icon: <FaChartPie />,
        link: routes.MARKET_VOLUME_SHARE,
        roles: [
          ROLES.ADMIN,
          ROLES.OPS_TEAM,
          ROLES.SHEDULER,
          ROLES.STAKE_HOLDERS,
          ROLES.TENANT_ADMIN,
          ROLES.SUPER_ADMIN,
        ],
      },
      {
        title: "Coverage Gap Tool",
        icon: <FaArrowsLeftRightToLine />,
        link: routes.COVERAGE_GAP_TOOL_ENCORE,
        roles: [
          ROLES.ADMIN,
          ROLES.OPS_TEAM,
          ROLES.SHEDULER,
          ROLES.STAKE_HOLDERS,
          ROLES.TENANT_ADMIN,
          ROLES.SUPER_ADMIN,
        ],
      },
      {
        title: "Performance Dashboard",
        icon: <FaGaugeSimpleHigh />,
        link: routes.PERFORMANCE_DASHBOARD_COMBINED,
        roles: [
          ROLES.ADMIN,
          ROLES.OPS_TEAM,
          ROLES.SHEDULER,
          ROLES.STAKE_HOLDERS,
          ROLES.TENANT_ADMIN,
          ROLES.SUPER_ADMIN,
        ],
      },
      {
        title: "Performance Dashboard Configuration",
        icon: <FaGears />,
        link: routes.REPORT_CONFIGURATION,
        roles: [
          ROLES.ADMIN,
          ROLES.OPS_TEAM,
          ROLES.SHEDULER,
          ROLES.STAKE_HOLDERS,
          ROLES.TENANT_ADMIN,
          ROLES.SUPER_ADMIN,
        ],
      },
    ],
  },
  /*
  {
    title: "Strategic Forecast",
    icon: <FaCubesStacked />,
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
    subMenus: [
      {
        title: "Encore Service Request",
        icon: <FaHandHoldingMedical />,
        link: routes.MATRIX_SERVICE_REQUEST,
        roles: [
          ROLES.ADMIN,
          ROLES.OPS_TEAM,
          ROLES.SHEDULER,
          ROLES.TENANT_ADMIN,
        ],
      },
      {
        title: "Strategic Demand Planner",
        icon: <FaArrowTrendUp />,
        link: routes.STRATEGIC_DEMAND_PLANNER,
        roles: [
          ROLES.ADMIN,
          ROLES.OPS_TEAM,
          ROLES.SHEDULER,
          ROLES.TENANT_ADMIN,
        ],
      },
      {
        title: "Strategic Capacity Planner",
        icon: <FaCubes />,
        link: routes.STRATEGIC_CAPACITY_PLANNER,
        roles: [
          ROLES.ADMIN,
          ROLES.OPS_TEAM,
          ROLES.SHEDULER,
          ROLES.TENANT_ADMIN,
        ],
      },
      {
        title: "Strategic Capacity vs Demand Planner",
        icon: <FaScaleUnbalancedFlip />,
        link: routes.STRATEGIC_CAPS_VS_DEMAND_PLANNER,
        roles: [
          ROLES.ADMIN,
          ROLES.OPS_TEAM,
          ROLES.SHEDULER,
          ROLES.TENANT_ADMIN,
        ],
      },
    ],
  },*/
  // { title: "Schedule", icon: <AiOutlineSchedule />, link: routes.SCHEDULE_PATH, roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER] },

  {
    title: "Volume Trend Report",
    icon: <FaArrowUpRightDots />,
    link: routes.VOLUME_TREND_REPORT,
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    title: "Demand Table",
    icon: <FaTable />,
    link: routes.DEMAND_TABLE,
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    title: "Capacity Table",
    icon: <FaTableList />,
    link: routes.CAPACITY_TABLE,
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  {
    title: "Capacity Vs Demand",
    icon: <FaScaleUnbalanced />,
    link: routes.CAPS_VS_DEMAND_TABLE,
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER, ROLES.TENANT_ADMIN],
  },
  /*
  // {
  //     title: "Demand Forecasting",
  //     icon: <FaCubesStacked />,
  //     roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER],
  //     subMenus: [
  //         { title: "Forecasting", icon: <FaRegChartBar />, link: routes.FORECAST, roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER] },
  //         { title: "Optimize", icon: <FaRegChartBar />, link: routes.FORECAST_OPTIMIZE, roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER] },
  //         { title: "Caps Vs Demand", icon: <FaRegChartBar />, link: routes.FORECAST_CAPSVSDEMAND, roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER] },
  //         { title: "Report", icon: <FaRegChartBar />, link: routes.FORECASTREPORT, roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER] },

  //     ]
  // },

  // {
  //     title: "Predictive Analytics",
  //     icon: <FaCubesStacked />,
  //     roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER],
  //     subMenus: [
  //         { title: "Forecast", icon: <FaRegChartBar />, link: routes.FORECASTING_FORECAST, roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER] },
  //         { title: "Optimize", icon: <FaRegChartBar />, link: routes.FORECASTING_OPTIMIZE, roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER] },
  //         { title: "Schedules", icon: <FaRegChartBar />, link:routes.FORECASTING_SCHEDULES, roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER] },
  //     ]
  // },

  // { title: "Optimize", icon: <FaGears />, link: routes.OPTIMIZE, roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER] },

  /*{
    title: "Scheduling",
    icon: <AiOutlineSchedule />,
    roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER],
    subMenus: [
      {
        title: "Schedule",
        icon: <FaCalendarDays />,
        link: routes.SCHEDULE_PATH,
        roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER],
      },
      {
        title: "Manage Links",
        icon: <FaLink />,
        link: routes.SCHEDULE_SHARE_LINKS,
        roles: [ROLES.ADMIN, ROLES.OPS_TEAM, ROLES.SHEDULER],
      },
    ],
  },*/

  // isExternal: the manual is a separate static site, so the sidebar opens it
  // in a new tab instead of routing to it inside the SPA.
  {
    title: "User Guide",
    icon: <FaRegCircleQuestion />,
    link: routes.USER_MANUAL_PATH,
    isExternal: true,
    roles: [
      ROLES.ADMIN,
      ROLES.OPS_TEAM,
      ROLES.SHEDULER,
      ROLES.PROVIDER,
      ROLES.STAKE_HOLDERS,
      ROLES.TENANT_ADMIN,
      ROLES.SUPER_ADMIN,
    ],
  },

  // The Encore mobile app's guide, hosted by the mobile app (another origin),
  // so it opens in a new tab. Providers only; hidden when public/config.js has
  // no MOBILE_USER_GUIDE_URL for the current environment.
  ...(routes.MOBILE_USER_GUIDE_URL
    ? [
        {
          title: "Mobile User Guide",
          icon: <FaMobileScreenButton />,
          link: routes.MOBILE_USER_GUIDE_URL,
          isExternal: true,
          roles: [ROLES.PROVIDER],
        },
      ]
    : []),
];
